/**
 * Botão de login/registo social (Google) para as páginas de login e registo.
 *
 * Google: usa o Emergent-managed Google Auth. Redireciona para
 * auth.emergentagent.com que, no fim, devolve o utilizador a
 * `/auth/social-callback#session_id=...` (ver SocialCallback.jsx).
 *
 * O cookie REFER (sponsor) é propagado para que contas novas criadas via
 * login social fiquem associadas ao consultor correto.
 */
import { getReferCookie } from "@/shared/auth/referCookie";

function startGoogle() {
  const refer = getReferCookie();
  const back = `${window.location.origin}/auth/social-callback${refer ? `?refer=${encodeURIComponent(refer)}` : ""}`;
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(back)}`;
}

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

export default function SocialAuthButtons({ variant = "light" }) {
  const dark = variant === "dark";
  const btn = {
    display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
    width: "100%", height: 46, borderRadius: 8, cursor: "pointer",
    fontSize: 14, fontWeight: 600, fontFamily: "inherit",
    border: `1px solid ${dark ? "rgba(255,255,255,0.3)" : "rgba(15,24,41,0.2)"}`,
    background: "#fff", color: "#0F1829", transition: "background-color 0.2s, border-color 0.2s",
  };
  return (
    <div data-testid="social-auth-buttons" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <button type="button" onClick={startGoogle} style={btn} data-testid="social-google-btn"
        onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}>
        <GoogleIcon /> Continuar com Google
      </button>
    </div>
  );
}

export function SocialAuthDivider({ variant = "light" }) {
  const dark = variant === "dark";
  const line = { flex: 1, height: 1, background: dark ? "rgba(255,255,255,0.2)" : "rgba(15,24,41,0.15)" };
  const txt = {
    fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 600,
    color: dark ? "rgba(255,255,255,0.6)" : "rgba(15,24,41,0.5)", whiteSpace: "nowrap",
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "18px 0" }}>
      <div style={line} /><span style={txt}>ou</span><div style={line} />
    </div>
  );
}
